import script from "./BrandRimCombinedWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandRimCombinedWidget.vue?vue&type=script&setup=true&lang=js"

import "./BrandRimCombinedWidget.vue?vue&type=style&index=0&id=08ba9766&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ba9766"]])

export default __exports__